module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"attendees":"Teilnehmer","noAttendeesAvailable":"Keine Teilnehmer vorhanden"},"en":{"attendees":"Attendee","noAttendeesAvailable":"No dates available"}}')
  delete Component.options._Ctor
}
